export default __webpack_public_path__ + "static/godineIskustva-96d5ccd5809dfc0e4255d5edb6e89d39.jpeg";